const getToken = () => localStorage.getItem("admin_crypto");

export const AdminAuthCheck = async () => {
  const token = getToken();
  try {
    const resp = await fetch("/admin/auth/check", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Auth Check" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const AdminLogin = async (body) => {
  try {
    const resp = await fetch("/admin/login", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    console.error("Admin Login" + error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const updateAdminPw = async (body) => {
  const token = getToken();

  try {
    const resp = await fetch(`/admin/change/pw`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    return await resp.json();
  } catch (error) {
    return { status: false, message: "Internet Server Error" };
  }
};

// Whitelist CapMode
export const getWhitelist = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event/admin/get${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/* ➕ POST – Add / Upsert cap + pid */
export const addWhitelist = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/add", {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { p_id }
    });
    return await resp.json();
  } catch (error) {
    console.error("Add Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/* ➕ POST – Add PID to existing cap */
export const updateWhitelistStatus = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/status", {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { p_id, isActive }
    });
    return await resp.json();
  } catch (error) {
    console.error("Update Status Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * 🗑️ DELETE whitelist by p_id
 * DELETE /api/event/admin/delete
 */
export const deleteWhitelist = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { ids: [] }
    });
    return await resp.json();
  } catch (error) {
    console.error("Delete Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/**
 * ✅ GET ONLY ACTIVE whitelist (all-time)
 * GET /api/event/admin/active
 */
export const getActiveWhitelist = async () => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/active", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Active Whitelist Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

/* ➕ GET – Unique Campaign Names for Filter */
export const getCampaignNames = async () => {
  const token = getToken();
  try {
    const resp = await fetch("/api/event/admin/campaigns", {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Campaign Names Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const getEventDashboard = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/dashboard${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Event Dashboard Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const getEventList = async (params = "") => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/list${params}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return await resp.json();
  } catch (error) {
    console.error("Get Event List Error", error);
    return { status: false, message: "Internet Server Error" };
  }
};

export const updateEventStatus = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/status`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { p_id, isActive }
    });
    return await resp.json();
  } catch (error) {
    console.error("Update Event Status Error", error);
    return { status: false, message: "Internet Server Error" };
  }
}

export const deleteTrackEvent = async (body) => {
  const token = getToken();
  try {
    const resp = await fetch(`/api/event-tracker/admin/delete`, {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body), // { ids: [] }
    });
    return await resp.json();
  } catch (error) {
    console.error("Delete Track Event Error", error);
    return { status: false, message: "Internet Server Error" };
  }
}
